import { langPath } from '@/utils/langPath';
import { useNavigate } from 'react-router-dom';

interface updateQueryProps {
  params: Record<string, any>;
  route: string;
}
export const useOrderQuery = () => {
  const navigate = useNavigate();

  const updateQuery = ({ params, route }: updateQueryProps) => {
    const searchParams = new URLSearchParams(window.location.search);

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        searchParams.delete(key);
      } else {
        searchParams.set(key, String(value));
      }
    });

    console.log(window.location);
    navigate(langPath(`${route}?${searchParams.toString()}`));
  };

  return { updateQuery };
};
